import { render, staticRenderFns } from "./OuterFacade.vue?vue&type=template&id=4cab7e61&scoped=true"
import script from "./OuterFacade.vue?vue&type=script&lang=js"
export * from "./OuterFacade.vue?vue&type=script&lang=js"
import style0 from "./OuterFacade.vue?vue&type=style&index=0&id=4cab7e61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab7e61",
  null
  
)

export default component.exports